import styled from "styled-components";
import Link from "next/link";
import { Row, Col, Grid } from "antd";
import { RATypography } from "@/components/customs";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
import { PATH_ROUTES } from "@/config/routes";
import { RAImage } from "@/components/customs";
import { useTrackVisibility } from "react-intersection-observer-hook";
import { SERVICES_STEP } from "./index";

const { useBreakpoint } = Grid;

export function HomeServices({ explore_our_innovative_solutions = {}, step = SERVICES_STEP.FIRST, snap = false }) {
	const screens = useBreakpoint();
	const [ref] = useTrackVisibility();
	return (
		<div
			style={{
				width: "100%",
				height: snap ? "100vh" : "100%",
				overflow: "hidden",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<div
				style={{
					width: "100%",
					display: "flex",
					flexDirection: "column",
					transition: "all 1s",
					zIndex: 1,
				}}
			>
				<IntroductionRow justify="center">
					<Col xs={22} lg={12}>
						<RATypography variant={screens?.md ? "h2" : "h4"} align="center">
							{explore_our_innovative_solutions?.title || ""}
						</RATypography>
					</Col>
					<Col xs={23} lg={14}>
						<RATypography variant="p" align="center" top="20px">
							{explore_our_innovative_solutions?.sub_title || ""}
						</RATypography>
					</Col>
				</IntroductionRow>
			</div>
			<div style={{ width: "100%", height: snap ? "50%" : "100%" }}>
				<HomeServicesContainer
					style={{
						position: "relative",
						height: `100%`,
						display: "flex",
						width: "100%",
						flexDirection: "column",
					}}
					ref={ref}
				>
					<EachRowContainer snap={snap.toString()}>
						<EachRow
							justify="center"
							align="middle"
							className={`animate__animated ${
								snap
									? step === SERVICES_STEP.FIRST
										? "animate__fadeInDown"
										: "animate__fadeOutDown"
									: ""
							}`}
							style={{
								zIndex: snap && step === SERVICES_STEP.FIRST ? 10 : 1,
							}}
						>
							<Col className="image-left" md={12} xs={24}>
								<RAImage
									url={
										explore_our_innovative_solutions?.hight_light1?.photo ||
										PATH_PUBLIC_IMAGES.img_services_private_jet
									}
									width="100%"
									height="100%"
									borderRadius="16px"
								/>
							</Col>
							<DescriptionCol md={12}>
								<RATypography variant="sub-heading2" bottom={screens?.md ? "20px" : "4px"}>
									{explore_our_innovative_solutions?.hight_light1?.title || ""}
								</RATypography>
								<RATypography variant="body3" bottom={screens?.md ? "20px" : "16px"} color="#595959">
									{explore_our_innovative_solutions?.hight_light1?.description || ""}
								</RATypography>
								<Row>
									<ButtonExplore
										title={explore_our_innovative_solutions?.hight_light1?.button_content || ""}
										href={explore_our_innovative_solutions?.hight_light1?.path || ""}
									/>
								</Row>
							</DescriptionCol>
						</EachRow>
					</EachRowContainer>
					<EachRowContainer snap={snap.toString()}>
						<EachRow
							justify="center"
							align="middle"
							className={`animate__animated ${
								snap
									? step === SERVICES_STEP.SECOND
										? "animate__fadeInDown"
										: "animate__fadeOutDown"
									: ""
							}`}
							style={{
								zIndex: snap && step === SERVICES_STEP.SECOND ? 10 : 1,
							}}
						>
							<DescriptionCol
								md={{
									span: 12,
									order: 1,
								}}
								xs={{
									span: 24,
									order: 2,
								}}
							>
								<RATypography variant="sub-heading2" bottom={screens?.md ? "20px" : "4px"}>
									{explore_our_innovative_solutions?.hight_light2?.title || ""}
								</RATypography>
								<RATypography variant="body3" bottom={screens?.md ? "20px" : "16px"} color="#595959">
									{explore_our_innovative_solutions?.hight_light2?.description || ""}
								</RATypography>
								<Row>
									<ButtonExplore
										title={explore_our_innovative_solutions?.hight_light2?.button_content || ""}
										href={explore_our_innovative_solutions?.hight_light2?.path || ""}
									/>
								</Row>
							</DescriptionCol>
							<Col
								className="image-right"
								md={{
									span: 12,
									order: 2,
								}}
								xs={{
									span: 24,
									order: 1,
								}}
							>
								<RAImage
									url={
										explore_our_innovative_solutions?.hight_light2?.photo ||
										PATH_PUBLIC_IMAGES.img_services_jet_one_suites
									}
									width="100%"
									height="100%"
									borderRadius="16px"
								/>
							</Col>
						</EachRow>
					</EachRowContainer>
					<EachRowContainer snap={snap.toString()}>
						<EachRow
							justify="center"
							align="middle"
							className={`animate__animated ${
								snap
									? step === SERVICES_STEP.THIRD
										? "animate__fadeInDown"
										: "animate__fadeOutDown"
									: ""
							}`}
							style={{
								zIndex: snap && step === SERVICES_STEP.THIRD ? 10 : 1,
							}}
						>
							<Col className="image-left" md={12} xs={24}>
								<RAImage
									url={
										explore_our_innovative_solutions?.hight_light3?.photo ||
										PATH_PUBLIC_IMAGES.img_services_air_freight
									}
									width="100%"
									height="100%"
									borderRadius="16px"
								/>
							</Col>
							<DescriptionCol md={12}>
								<RATypography variant="sub-heading2" bottom={screens?.md ? "20px" : "4px"}>
									{explore_our_innovative_solutions?.hight_light3?.title || ""}
								</RATypography>
								<RATypography variant="body3" bottom={screens?.md ? "20px" : "16px"} color="#595959">
									{explore_our_innovative_solutions?.hight_light3?.description || ""}
								</RATypography>
								<Row>
									<ButtonExplore
										title={explore_our_innovative_solutions?.hight_light3?.button_content || ""}
										href={explore_our_innovative_solutions?.hight_light3?.path || ""}
									/>
								</Row>
							</DescriptionCol>
						</EachRow>
					</EachRowContainer>
				</HomeServicesContainer>
			</div>
		</div>
	);
}

export function ServicesIntroduction({ explore_our_innovative_solutions = {} }) {
	const screens = useBreakpoint();
	return (
		<Container
			style={{
				width: "100vw",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<Row justify="center" style={{ maxWidth: 1442, width: "100%" }}>
				<Col span={16}>
					<RATypography variant={screens?.md ? "h2" : "h4"} align="center">
						{explore_our_innovative_solutions?.title || ""}
					</RATypography>
				</Col>
			</Row>
			<Row justify="center" style={{ maxWidth: 1442, width: "100%" }}>
				<Col span={18}>
					<RATypography variant="p" align="center" top="20px">
						{explore_our_innovative_solutions?.sub_title || ""}
					</RATypography>
				</Col>
			</Row>
		</Container>
	);
}

export function HomeEachService({ explore_our_innovative_solutions = {}, step = SERVICES_STEP.FIRST }) {
	const screens = useBreakpoint();
	const renderTItle = () => {
		switch (step) {
			case SERVICES_STEP.FIRST:
				return explore_our_innovative_solutions?.hight_light1?.title;
			case SERVICES_STEP.SECOND:
				return explore_our_innovative_solutions?.hight_light2?.title;
			case SERVICES_STEP.THIRD:
				return explore_our_innovative_solutions?.hight_light3?.title;
			default:
				return "";
		}
	};

	const renderDescription = () => {
		switch (step) {
			case SERVICES_STEP.FIRST:
				return explore_our_innovative_solutions?.hight_light1?.description;
			case SERVICES_STEP.SECOND:
				return explore_our_innovative_solutions?.hight_light2?.description;
			case SERVICES_STEP.THIRD:
				return explore_our_innovative_solutions?.hight_light3?.description;
			default:
				return "";
		}
	};

	const renderPhoto = () => {
		switch (step) {
			case SERVICES_STEP.FIRST:
				return explore_our_innovative_solutions?.hight_light1?.photo;
			case SERVICES_STEP.SECOND:
				return explore_our_innovative_solutions?.hight_light2?.photo;
			case SERVICES_STEP.THIRD:
				return explore_our_innovative_solutions?.hight_light3?.photo;
			default:
				return PATH_PUBLIC_IMAGES.img_services_air_freight;
		}
	};

	const renderButtonContent = () => {
		switch (step) {
			case SERVICES_STEP.FIRST:
				return explore_our_innovative_solutions?.hight_light1?.button_content;
			case SERVICES_STEP.SECOND:
				return explore_our_innovative_solutions?.hight_light2?.button_content;
			case SERVICES_STEP.THIRD:
				return explore_our_innovative_solutions?.hight_light3?.button_content;
			default:
				return "";
		}
	};

	const getOrderImage = () => {
		switch (step) {
			case SERVICES_STEP.FIRST:
				return 1;
			case SERVICES_STEP.SECOND:
				return 2;
			case SERVICES_STEP.THIRD:
				return 1;
			default:
				return 1;
		}
	};

	const getOrderDescription = () => {
		switch (step) {
			case SERVICES_STEP.FIRST:
				return 2;
			case SERVICES_STEP.SECOND:
				return 1;
			case SERVICES_STEP.THIRD:
				return 2;
			default:
				return 2;
		}
	};

	const getPathService = () => {
		switch (step) {
			case SERVICES_STEP.FIRST:
				return explore_our_innovative_solutions?.hight_light1?.path ?? "";
			case SERVICES_STEP.SECOND:
				return explore_our_innovative_solutions?.hight_light2?.path ?? "";
			case SERVICES_STEP.THIRD:
				return explore_our_innovative_solutions?.hight_light3?.path ?? "";
			default:
				return PATH_ROUTES.PATH_HOME;
		}
	};
	return (
		<EachRowContainer>
			<EachRow
				justify="center"
				align="middle"
				style={{
					animationDuration: "0.3s",
				}}
			>
				<DescriptionCol
					md={{
						span: 12,
						order: getOrderDescription(),
					}}
					xs={{
						span: 24,
						order: 2,
					}}
					step={step}
				>
					<RATypography variant="sub-heading2" bottom={screens?.md ? "20px" : "4px"}>
						{renderTItle()}
					</RATypography>
					<RATypography variant="body3" bottom={screens?.md ? "20px" : "16px"} color="#595959">
						{renderDescription()}
					</RATypography>
					<Row>
						<ButtonExplore title={renderButtonContent()} href={getPathService()} />
					</Row>
				</DescriptionCol>
				<Col
					style={{ height: "100%" }}
					className="image-right"
					md={{
						span: 12,
						order: getOrderImage(),
					}}
					xs={{
						span: 24,
						order: 1,
					}}
				>
					<RAImage
						url={renderPhoto()}
						width="100%"
						height={screens?.md ? "384px" : "210px"}
						borderRadius="16px"
					/>
				</Col>
			</EachRow>
		</EachRowContainer>
	);
}

const ButtonExplore = ({ title, href }) => {
	return (
		<div className="center">
			<Link href={href}>
				<button className="btn">
					<svg width="208" height="51.5" viewBox="0 0 208 51.5" className="border">
						<rect x="1" y="1" width="206" height="50" rx="25" />
					</svg>
					<span>{title}</span>
				</button>
			</Link>
		</div>
	);
};
const IntroductionRow = styled(Row)`
	padding: 20px 0;
	width: 100vw;
	max-width: 1442px;
`;
const EachRowContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-items: flex-start;
	position: ${({ snap }) => (snap === "true" ? "absolute" : "static")};
	.center {
		width: 208px;
		height: 52px;
	}
	.btn {
		width: 208px;
		height: 52px;
		border-radius: 50px;
		cursor: pointer;
		background: transparent;
		border: 1px solid #ffb11a;
		outline: none;
		transition: 2s ease-in-out;
		box-sizing: border-box;
		position: relative;
	}
	svg {
		position: absolute;
		left: -1px;
		top: -1px;
		fill: none;
		stroke: #404040;
		stroke-dasharray: 150 480;
		stroke-dashoffset: 150;
		transition: 2s ease-in-out;
		z-index: 100;
		box-sizing: border-box;
	}
	.btn:hover {
		transition: 2s ease-in-out;
	}
	.btn:hover svg {
		stroke-dashoffset: -480;
	}
	.btn span {
		color: #222222;
		font-family: "DM Sans";
		font-weight: 500;
		font-size: 14px;
		letter-spacing: 3px;
		text-transform: uppercase;
		text-indent: 3px;
	}
`;
const EachRow = styled(Row)`
	margin: 50px 0;
	padding: 60px 0;
	@media (max-width: 797px) {
		margin: 32px 0;
		padding: 40px 0;
	}
	@media (max-width: 575px) {
		margin: 24px 0;
		padding: 0 0 20px;
		border-radius: 12px;
		background: #fff;
		box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.04);
	}
`;
const DescriptionCol = styled(Col)`
	padding: ${({ step }) => (step === SERVICES_STEP.SECOND ? `0 72px 0 20px` : "0 20px 0 72px")};
	@media (max-width: 797px) {
		padding: 16px 20px 20px 20px;
	}
`;
const Container = styled.div`
	@media (max-width: 575px) {
		padding-top: 30px;
	}
`;
const HomeServicesContainer = styled.div`
	.image-left {
		padding-right: 40px;
		height: 360px;
	}
	.image-right {
		padding-left: 40px;
		height: 360px;
	}
	@media (max-width: 767px) {
		.image-left {
			padding-right: 0;
			height: 210px;
		}
		.image-right {
			padding-left: 0;
			height: 210px;
		}
		${EachRow} {
			box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.04);
			border-radius: 12px;
		}
	}
`;
